var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Can',{attrs:{"I":"view","a":"roles_journal"}},[_c('Table',{attrs:{"title":'Роли',"editDialog":_vm.editDialog,"headers":_vm.headers,"dense":true,"apiStore":_vm.apiStore,"nameJournal":"roles_journal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }